module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"activationSuccessfulPage":{"title":"Meine DA Direkt ist aktiviert","text":"Egal ob Kfz-Versicherung, Haftpflicht-, Rechtsschutz-, Hausrat- oder Unfallversicherung:<br>In <strong>Meine DA Direkt</strong> finden Sie alle Ihre Vertragsdokumente, Beitragsrechnungen und Mitteilungen.<br><br>Melden Sie sich jetzt an.","primaryButtonText":"Zur Anmeldung"}}}')
  delete Component.options._Ctor
}
